import { HD, FULL_HD } from '@bedrock-rdk/constants';

export const HEIGHT = {
  [HD]: 72,
  [FULL_HD]: 80,
};

export const BACKGROUND_RADIUS = 0;

export const BAR_OFFSET_LEFT = 8;

export const BAR_OPACITY = 0.1;

export const TEXT_FONT = 'KINSHASA_2';
